export default __webpack_public_path__ + "resources/icons/d110-52b2.png";